import src from "IMAGE";
export default { src, width: 98, height: 19, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARElEQVR42g3KsQ2AIAAF0R8XMK7jECYWWqu9kAANCYxATUXBDCzIFa+45DTaVu9jeSX9SLjgcGJXL2tmsIRBxIcAj2cCjmwKmn5OBjUAAAAASUVORK5CYII="};
